exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".package-columns-selectors-container {\n  display: flex;\n  flex: 1;\n}\n.package-columns-selectors-container .columns-divider {\n  margin: 0 !important;\n  height: unset !important;\n}\n", ""]);

// exports
